import { COLOR_CRIMSON, COLOR_CYAN, COLOR_YELLOW } from '@/constants/constants'

export const STICKY_NOTES_COLORS = [COLOR_YELLOW, COLOR_CYAN, COLOR_CRIMSON]

// A note hangs on a page or a tree section and moves with it (OCT-5256); the
// elements it can hang on carry this attribute with their id. Anything else —
// the bare canvas — leaves the note free on its tab.
export const NOTE_TARGET = 'data-note-target'

// Each notes layer carries the id of what its notes hang on. The layer sits at
// the point their offsets are measured from: the top left corner of a page,
// the top middle of a section, the top middle of the tree for a tab.
export const NOTE_ORIGIN = 'data-note-origin'

// The page or section a dragged note would hang on carries this class. It is
// put on by the drag itself rather than through the store: on a big map one
// store update re-renders for half a second, and a drag crosses several targets.
export const NOTE_TARGET_CLASS = 'is-note-target'
